<template>
	<!-- <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" dark app fixed > -->
	<v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" dark app fixed>

		<v-toolbar-title class="ml-0 ToolbarTitle">
			<v-toolbar-side-icon @click.stop="doTrigDrawer()"></v-toolbar-side-icon>
			<span class="hidden-sm-and-down">Robotic Lakawi QBZ</span>
		</v-toolbar-title>

		<!-- <v-text-field flat solo-inverted hide-details prepend-inner-icon="search" label="Search" ></v-text-field> -->

		<v-autocomplete v-model="domainsearch.select" :loading="domainsearch.loading" :items="domainsearch.items"
			:search-input.sync="domainsearch.search" cache-items class="mx-3" flat hide-no-data hide-details
			label="Bir domain yada site adı yazın" solo-inverted v-on:keyup.enter="DomainSearchEnter()"
			v-on:change="DomainSearchChanged()"></v-autocomplete>

		<!-- <v-btn icon>
			<v-icon>apps</v-icon>
		</v-btn> -->

		<v-spacer></v-spacer>

		<!-- <v-btn icon>
			<v-icon>apps</v-icon>
		</v-btn>
		<v-btn icon>
			<v-icon>notifications</v-icon>
		</v-btn> -->
		<v-btn icon large class="ToolbarProfileButton" @click="gotoProfile()">
			<v-avatar size="44px" tile>
				<img :src="getSignedUser.logo" alt="Vuetify">
			</v-avatar>
		</v-btn> 
		<ToolbarDomainDetail :show="domainsearch.dialog" :domain="DomainSearchGetDomain"
			v-on:DomainSearchDialogClose="DomainSearchDialogClose()" />

	</v-toolbar>
</template>


<script>
	import ToolbarDomainDetail from "@/components/layout/ToolbarDomainDetail"

	export default {
		name: "Toolbar",
		props: {
			drawer: Boolean
		},
		components: {
			ToolbarDomainDetail
		},
		data: () => ({

			domainsearch: {
				loading: false,
				items: [],
				search: "",
				select: "",
				domainlist: [ ],
				dialog: false,
				selectedDomain : ""
			},


		}),
		watch: {
			"domainsearch.search"(val) {
				val && val !== this.domainsearch.select && this.DomainSearchQuery(val)
			}
		},
		mounted(){
			this.loadDomains();
		},
		methods: {

			gotoProfile(){
				this.$router.push({
					path: '/profile',
					query: { }
				})
			},


			loadDomains(){ 
				this.$http.get( process.env.VUE_APP_API_URL + "/server/domains/justdomains", {
					params : { }
				}).then(response => {  
					this.domainsearch.domainlist = response.body; 
				}) 
			},
			doTrigDrawer() {
				this.$emit("drawed", !this.drawer)
			},

			DomainSearchQuery(v) {
				this.domainsearch.loading = true 
				setTimeout(() => {
					this.domainsearch.items = this.domainsearch.domainlist.filter(e => {
						return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
					})
					this.domainsearch.loading = false
				}, 10)
			},
			DomainSearchChanged() { 
				this.domainsearch.selectedDomain = this.domainsearch.select 
				this.DomainSearchDialogOpen();
			},
			DomainSearchEnter() {
				this.domainsearch.selectedDomain = this.domainsearch.search 
				this.DomainSearchDialogOpen();
			},
			DomainSearchDialogOpen() { 
				this.domainsearch.dialog = true;
			},
			DomainSearchDialogClose() {
				this.domainsearch.dialog = false;
			}
		},
		computed : {
			DomainSearchGetDomain() {
				let domain = this.domainsearch.selectedDomain.trim()
				// domain.replace('https://','').replace('http://','').replace('://','')
				if(domain.indexOf('.') < 0){
					domain += ".com"
				}
				if(domain.indexOf('/') > 0){
					domain = domain.substring(0, domain.indexOf('/'))
				}
				return domain
			},
			getSignedUser(){
				return this.$store.state.signedUser
			}
		}

	}
</script>


<style lang="less">
	.ToolbarTitle {
		width: 260px;

		@media(max-width:960px) {
			width: 50px;
		}
	}
	.ToolbarProfileButton{
		img{
			border-radius: 50%;
			object-fit: cover;
			width : 44px;
			height : 44px;
		}
	}
</style>